const {REACT_APP_BASE_URL}=process.env
// export const baseUrl = REACT_APP_BASE_URL;
export const baseUrl = REACT_APP_BASE_URL||"https://development-salon-backend-xi.vercel.app";

export const headers = {
    "Content-Type": "application/json",
}

export const jwtHeaders = () => {
    const headers = {
        "Content-Type": "application/json",
        // "Authorization": `Bearer ${JSON.parse(localStorage.getItem("salon-staff"))?.token}`,
        Authorization: `${localStorage.getItem('staff_token')}`,
    }
    return headers;
}

export const jwtHeaders2 = () => {
    const headers = {
        // "Content-Type": "application/json",
        // "Authorization": `Bearer ${JSON.parse(localStorage.getItem("salon-staff"))?.token}`,
        Authorization: `${localStorage.getItem('staff_token')}`,
    }
    return headers;
}

export const logoutUtil = () => {
    localStorage.removeItem("salon-staff");
    window.location.href = "/login";
};